"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var assessmentsApi_1 = __importDefault(require("../../mock/assessmentsApi"));
var AssessmentsAPIs = {
    getUserAssessments: function () {
        return rest_1.default.get({
            mockFunc: function () { return assessmentsApi_1.default; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/assessments/user-assessments'),
        });
    },
};
exports.default = AssessmentsAPIs;
